import React from 'react'
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Helmet } from "react-helmet-async";
import TestSlider from '../Components/slider/TestSlider';
import LogoSlider from '../Components/slider/LogoSlider';


const clients = [
    {
        img: "/assets/home/item4.svg",
        title: "Best Cable Termination Company in Fujairah",
        text: "Al Ibtekar provides professional cable termination support and solutions for electrical contractors, engineers, technicians, and industrial businesses across Fujairah, and the UAE. Our focus is on reliable products, technical expertise, and practical solutions for demanding cable termination requirements.",
        link: "/about-us"
    },

    {
        img: "/assets/home/newc1.png",
        title: "Professional Cable Termination Support",
        text: "We provide technical support for cable cutting, cable preparation, stripping, crimping, termination tools, and related cable termination requirements. Our team works with clients to identify the right approach for every project and application.",
        link: "/about-us"
    },

    {
        img: "/assets/home/newc5.png",
        title: "Experienced Technical Team",
        text: "Our technical team understands the practical requirements of cable termination and electrical installation work. We support contractors, engineers, and site teams with technical guidance, product selection, and application-focused solutions.",
        link: "/about-us"
    },

    {
        img: "/assets/home/newc7.png",
        title: "Cable Termination Services in Fujairah",
        text: "From cable preparation and stripping to crimping, tool selection, and technical guidance, Al Ibtekar supports electrical and industrial projects across Fujairah with dependable cable termination solutions.",
        link: "/product-services"
    },

    {
        img: "/assets/home/newc2.png",
        title: "Cable Termination Services in Fujairah",
        text: "We support businesses and project teams in Fujairah with professional cable termination solutions, termination accessories, crimping tools, technical support, and practical guidance for electrical installation requirements.",
        link: "/product-services"
    },

    {
        img: "/assets/home/newc3.png",
        title: "Cable Cutting, Stripping & Crimping",
        text: "Our cable termination support includes cable cutting, preparation, stripping, crimping, tool selection, and application guidance to help achieve consistent and reliable termination results.",
        link: "/product-services"
    },

    {
        img: "/assets/home/item4.svg",
        title: "Termination Tool Selection & Support",
        text: "Choosing the right termination tool is essential for safe and consistent cable preparation and crimping. We help customers identify suitable tools and solutions based on their cable, connector, and application requirements.",
        link: "/product-services"
    },

    {
        img: "/assets/home/newc4.png",
        title: "Cable Termination Training & Technical Guidance",
        text: "We provide practical technical guidance and training support for cable termination processes, helping technicians and project teams improve their understanding of cable preparation, crimping tools, and proper termination practices.",
        link: "/about-us"
    }
];


const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, ease: 'easeOut' }
    },
};


function CTFujairah() {

    const AnimateSection = ({ children }) => {
        const [ref, inView] = useInView({
            triggerOnce: true,
            threshold: 0.15
        });

        return (
            <motion.div
                ref={ref}
                variants={fadeUp}
                initial="hidden"
                animate={inView ? "visible" : "hidden"}
            >
                {children}
            </motion.div>
        );
    };


    return (
        <div>

            <Helmet>

                <title>
                    Best Cable Termination Company in Fujairah | Al Ibtekar
                </title>

                <meta
                    name="description"
                    content="Al Ibtekar is a leading cable termination company in Fujairah, providing professional cable termination support, cable cutting, stripping, crimping, termination tools, technical guidance, training and related services across the UAE."
                />

                <meta
                    name="keywords"
                    content="best cable termination company Fujairah, cable termination company Fujairah, cable termination services Fujairah, cable termination services Fujairah, cable termination UAE, cable termination support Fujairah, cable termination support Fujairah, cable crimping Fujairah, cable crimping Fujairah, cable cutting services UAE, cable stripping services UAE, cable termination tools Fujairah, cable termination tools Fujairah, cable lug crimping UAE, cable termination training UAE, cable termination services UAE"
                />

                <link
                    rel="canonical"
                    href="https://saig.me/cable-termination"
                />

                <meta
                    property="og:title"
                    content="Best Cable Termination Company in Fujairah | Al Ibtekar"
                />

                <meta
                    property="og:description"
                    content="Professional cable termination support and services in Fujairah, Fujairah and across the UAE, including cable preparation, cutting, stripping, crimping, tool selection, technical guidance and training."
                />

                <meta
                    property="og:url"
                    content="https://saig.me/cable-termination"
                />

                <meta
                    property="og:type"
                    content="website"
                />

            </Helmet>


            {/* HERO SECTION */}

            <div className='newbanner-about newbanner-about2'>

                <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">

                    <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">
                        Best Cable Termination Company in Fujairah
                    </h6>

                </div>

            </div>


            {/* ABOUT US SECTION */}

            <section className='pt-[30px] lg:pb-[30px] pb-[30px]'>

                <AnimateSection>

                    <div className="flex lg:flex-row max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] flex-col lg:gap-[120px] gap-[50px] justify-between items-center">

                        <div>

                            <img
                                style={{
                                    width: '600px',
                                    height: '600px',
                                    objectFit: 'cover',
                                    borderRadius: '20px'
                                }}
                                src="/assets/ct.jpeg"
                                alt="Al Ibtekar cable termination team in Fujairah"
                            />

                        </div>


                        <div>

                            <p className="font-[400] font-kanit text-[14px] leading-[20px] uppercase tracking-[2px] text-[#FBB210] pb-[15px]">
                                ABOUT US
                            </p>


                            <h6 className="font-[500] font-kanit lg:text-[42px] text-[26px] lg:leading-[50px] leading-[34px] tracking-[0.2px] text-[#0F0F0F] max-w-[520px] w-full pb-[20px]">
                                Cable Termination Company in Fujairah
                            </h6>


                            <p className="max-w-[605px] w-full font-[300] font-kanit text-[17px] leading-[27px] text-[#616161] pb-[40px]">

                                Al Ibtekar is a professional cable termination company serving Fujairah and clients across the UAE with reliable cable termination support, products, tools, and technical solutions.

                                <br /><br />

                                We work with electrical contractors, engineers, technicians, industrial businesses, and project teams that require dependable solutions for cable preparation and termination applications.

                                <br /><br />

                                Our cable termination support covers cable cutting, cable preparation, stripping, crimping, termination tools, tool selection, technical guidance, and related cable management requirements. We focus on understanding the practical requirements of each project before recommending the right solution.

                                <br /><br />

                                With a strong focus on technical expertise, product quality, reliability, and responsive customer support, Al Ibtekar aims to be a trusted cable termination partner for customers in Fujairah and across the UAE.

                            </p>

                        </div>

                    </div>

                </AnimateSection>

            </section>


            {/* OUR VALUES SECTION */}

            <section
                className='lg:pt-[60px] pt-[60px] pb-[60px] relative overflow-hidden'
                style={{
                    background: `radial-gradient(104.59% 215.16% at 95% 10%, rgba(228, 74, 26, 0.16) 0%, rgba(228, 74, 26, 0) 29%), radial-gradient(104.59% 215.16% at 5% 90%, rgba(255, 27, 153, 0.15) 0%, rgba(255, 27, 153, 0) 25%)`
                }}
            >

                <AnimateSection>

                    <div className="absolute top-[60px] left-[50px]">

                        <img
                            src="/assets/home/wrap2.svg"
                            alt="Cable termination solutions in Fujairah"
                        />

                    </div>


                    <div className='relative max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]'>

                        <p className="font-[400] font-kanit text-left text-[14px] leading-[20px] uppercase tracking-[2px] text-[#FBB210] pb-[15px]">
                            Our Values
                        </p>


                        <h6 className="font-[500] font-inter text-left lg:text-[42px] text-[26px] lg:leading-[50px] leading-[34px] tracking-[0.2px] text-[#0F0F0F] lg:pb-[130px] pb-[30px]">
                            Technical Expertise. Reliable Termination. Better Solutions.
                        </h6>

                    </div>


                    <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]'>

                        <div className='border-t-[2px] lg:border-[#49577A66] border-transparent flex flex-wrap lg:gap-[30px] gap-0 lg:justify-center'>


                            {/* QUALITY */}

                            <div className='lg:pt-[40px] pt-[20px]'>

                                <img
                                    src="/assets/value/item1.svg"
                                    className='h-[40px] object-cover'
                                    alt="Quality cable termination solutions"
                                />

                                <h6 className="pt-[30px] pb-[10px] font-[500] font-kanit text-[22px] leading-[33px] tracking-[0.3px] text-[#0F0F0F]">
                                    Quality & Reliability
                                </h6>

                                <p className="max-w-[260px] w-full font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A] pb-[22px]">
                                    We focus on reliable cable termination solutions designed to support demanding electrical and industrial applications.
                                </p>

                            </div>


                            <div className="line1"></div>


                            {/* TECHNICAL EXPERTISE */}

                            <div className='lg:pt-[40px] pt-[20px]'>

                                <img
                                    src="/assets/value/item2.svg"
                                    className='h-[40px] object-cover'
                                    alt="Technical cable termination expertise"
                                />

                                <h6 className="pt-[30px] pb-[10px] font-[500] font-kanit text-[22px] leading-[33px] tracking-[0.3px] text-[#0F0F0F]">
                                    Technical Expertise
                                </h6>

                                <p className="max-w-[260px] w-full font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A] pb-[22px]">
                                    Our technical knowledge helps customers select practical cable termination products, tools, and solutions for their applications.
                                </p>

                            </div>


                            <div className="line2"></div>


                            {/* CUSTOMER SUPPORT */}

                            <div className='lg:pt-[40px] pt-[20px]'>

                                <img
                                    src="/assets/value/item3.svg"
                                    className='h-[40px] object-cover'
                                    alt="Cable termination customer support"
                                />

                                <h6 className="pt-[30px] pb-[10px] font-[500] font-kanit text-[22px] leading-[33px] tracking-[0.3px] text-[#0F0F0F]">
                                    Customer Support
                                </h6>

                                <p className="max-w-[260px] w-full font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A] pb-[22px]">
                                    We provide responsive technical and product support to help contractors and project teams meet their cable termination requirements.
                                </p>

                            </div>


                            <div className="line3"></div>


                            {/* SAFETY */}

                            <div className='lg:pt-[40px] pt-[20px]'>

                                <img
                                    src="/assets/value/item4.svg"
                                    className='h-[40px] object-cover'
                                    alt="Safe cable termination practices"
                                />

                                <h6 className="pt-[30px] pb-[10px] font-[500] font-kanit text-[22px] leading-[33px] tracking-[0.3px] text-[#0F0F0F]">
                                    Safety & Compliance
                                </h6>

                                <p className="max-w-[260px] w-full font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A] pb-[22px]">
                                    We support safe, consistent, and standards-focused cable preparation and termination practices for electrical installations.
                                </p>

                            </div>

                        </div>

                    </div>

                </AnimateSection>

            </section>


            {/* WHY CHOOSE US */}

            <section className="bg-[#FFFFFF] py-[60px] md:py-[50px]">

                <div className="max-w-[1440px] flex flex-col lg:flex-row justify-between items-start mx-auto w-full gap-[40px] lg:px-[50px] px-[20px]">


                    <div className="lg:max-w-[480px] max-w-[100%] w-full text-[#000000] lg:sticky lg:top-[150px] self-start">

                        <h6
                            data-aos="fade-right"
                            className="text-[28px] lg:text-[48px] font-outfit font-[400] mb-[24px] leading-[40px] lg:leading-[56px]"
                        >
                            Why choose us
                        </h6>


                        <p className="font-outfit text-[16px] font-[400] leading-[24px] mb-[20px] md:mb-[36px]">

                            <strong>Reliable Cable Termination. Technical Expertise. Local Support.</strong>

                            <br /><br />

                            Al Ibtekar provides professional cable termination support for customers across Fujairah and the UAE. We combine technical knowledge, quality-focused solutions, and responsive customer support to help electrical contractors, engineers, technicians, and industrial businesses handle their cable termination requirements with confidence.

                        </p>


                        <div className="group inline-flex items-center h-[50px] cursor-pointer rounded-[10px] px-[20px]">

                            <i className="bi bi-arrow-right text-[#000] mt-[-5px] text-[40px] leading-[40px] transition-transform duration-300 ease-in-out group-hover:translate-x-2"></i>

                        </div>

                    </div>


                    <div className="lg:max-w-[600px] max-w-[100%] w-full">

                        <div className="grid gap-[20px]">

                            {clients.map((item, index) => (

                                <div key={index}>

                                    <div
                                        className="nsr border group relative rounded-[8px] backdrop-blur-[10px] p-[15px] md:p-[20px] pr-[60px] md:pr-[74px] transition-all duration-300 transform hover:scale-[1.03] hover:shadow-lg hover:bg-[#FBB210] hover:text-white"
                                        style={{ boxShadow: "0px 4px 10px 0px #0000000D" }}
                                    >

                                        <div className="flex flex-col sm:flex-row gap-[15px] md:gap-[30px] items-start">

                                            <div className="text-[#000] dark:text-[#000000] group-hover:text-white transition-colors duration-300">

                                                <h6 className="text-[20px] font-outfit md:text-[24px] lg:text-[26px] font-[500] mb-[15px] md:mb-[25px] transition-colors duration-300">

                                                    {item.title}

                                                </h6>


                                                <p className="text-[14px] font-outfit font-[400] leading-[20px] transition-colors duration-300">

                                                    {item.text}

                                                </p>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            ))}

                        </div>

                    </div>

                </div>

            </section>


            {/* TESTIMONIALS - UNCHANGED */}

            <section
                className="overflow-hidden pt-[5px]"
                style={{
                    background: `radial-gradient(101.52% 172.9% at 90% 80%, rgba(228, 74, 26, 0.15) 0%, rgba(228, 74, 26, 0) 20%), radial-gradient(88.64% 150.96% at 20% 35%, rgba(255, 27, 153, 0.15) 0%, rgba(255, 27, 153, 0) 25%)`
                }}
            >

                <div className="our-test lg:px-[50px] px-[20px] max-w-[1440px] w-full mx-auto">

                    <motion.p
                        className="font-[400] font-kanit text-left text-[14px] leading-[20px] uppercase tracking-[2px] text-[#FBB210] pb-[15px]"
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.2 }}
                    >
                        Testimonials
                    </motion.p>


                    <motion.h6
                        className="font-[500] text-left font-kanit lg:text-[42px] text-[26px] lg:leading-[50px] leading-[34px] tracking-[0.2px] text-[#0F0F0F] pb-[80px]"
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ delay: 0.2 }}
                    >
                        What our clients say about us
                    </motion.h6>


                    <div className="test-slider">

                        <TestSlider />

                    </div>

                </div>


                <div className='overflow-hidden lg:py-[106px] py-[40px]'>

                    <LogoSlider />

                </div>

            </section>


        </div>
    )
}


export default CTFujairah